var _path, _rect, _line, _g, _rect2, _g2, _rect3, _polygon, _polygon2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpStandard3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "700px",
    height: "775.6px",
    viewBox: "0 0 700 775.6",
    enableBackground: "new 0 0 700 775.6",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M477.3,548.9c0,0,5.2,7.3,13.2,7.3s13.2-6.8,13.2-6.8s3.5-2.9,8.1-0.5 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.8,
    y: 0,
    fill: "#EDEDED",
    width: 701.6,
    height: 775
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 700.8,
    y1: 740.5,
    x2: -0.8,
    y2: 740.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 209.9,
    y: 143,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 166.1,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 0.3,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M229.4,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0s15.1,0,15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M199.2,751.9c-6.8-2.9-10.4,1.1-10.4,1.1 s-4.5,6.9-10.9,6.9c-8,0-13.2-8-13.2-8v-732h34.5V751.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M164.7,751.9c-6.8-2.9-10.4,1.1-10.4,1.1 s-4.5,6.9-10.9,6.9c-8,0-13.2-8-13.2-8v-732h34.5V751.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M470.6,750.8c0,0,7.7,9,15.6,9.1 c7.9,0.1,14.6-8,14.6-8v-732c0,0-4.9,0-15.1,0c-10.2,0-15.1,0-15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M500.8,751.9c6.8-2.9,10.4,1.1,10.4,1.1 s4.5,6.9,10.9,6.9c8,0,13.2-8,13.2-8v-732h-34.5V751.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M535.3,751.9c6.8-2.9,10.4,1.1,10.4,1.1 s4.5,6.9,10.9,6.9c8,0,13.2-8,13.2-8v-732h-34.5V751.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M259.2,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0s15.1,0,15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M289.4,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M319.6,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M349.8,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M380,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M410.2,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M440.4,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V750.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M470.6,750.8c0,0-7.7,9-15.6,9.1 c-7.9,0.1-14.6-8-14.6-8v-732c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V750.8z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "#EDEDED",
    stroke: "#717070",
    strokeWidth: 0.6284,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 700,
    height: 32.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DADADA",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 690.5,41.9 700,32.3 570.2,32.3 570.1,41.9 689.2,41.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#DADADA",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 9.5,41.9 0,32.3 129.8,32.3 129.9,41.9 10.8,41.9 "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.9,
    y: 143,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 166.1,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.9,
    y: 143,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 166.1,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpStandard3);
export default __webpack_public_path__ + "static/media/CP_standard3.14e391f7a20e8ce0e78a2d8a217fdcb8.svg";
export { ForwardRef as ReactComponent };